module.exports = __webpack_public_path__ + "img/doctor.a5e51f96.svg";